<template>
  <!-- Footer container -->
  <footer class="bg-neutral-400 text-neutral-200">
    <div class="py-20">
      <div class="flex items-center justify-center mb-6">
        <h2 class="text-xl md:text-5xl tracking-widest ">医院案内</h2>
      </div>
      <div class="flex flex-col md:flex-row">
        <section class="ginza basis-1/2 pb-12 md:pb-0">
          <div class="flex p-10 md:pt-16 md:pb-12 justify-center items-center">
            <div>
              <img class="h-20 md:h-28" src="@/assets/img/logo/ginzalogo.png" alt="ginza logo">
              <ul class="inline-flex gap-4 list-inside list-none mt-4">
                <li>● 内科</li>
                <li>● 皮膚科</li>
              </ul>
            </div>
          </div>
          <p class="mb-4 pb-6 flex items-center justify-center">
            <img class="w-5/6 md:w-1/2" src="@/assets/img/map.png" alt="map">
          </p>
          <p class="mb-6 flex items-center justify-center">
            <a href="https://goo.gl/maps/KUohiZjWRzmdscpY7" target="_blank"
               class="pt-3 text-center before:ease relative h-14 w-40 overflow-hidden border border-white shadow-2xl before:absolute before:left-0 before:-ml-2 before:h-48 before:w-48 before:origin-top-right before:-translate-x-full before:translate-y-12 before:-rotate-90 before:bg-gray-900 before:transition-all before:duration-300 hover:text-white hover:shadow-black hover:before:-rotate-180">
              <span class="relative z-10 font-thin">google map</span>
            </a>
          </p>
          <p class="mb-4 flex items-center justify-center">
            〒104-0061 東京都中央区銀座 1-4-5<br class="sm:block md:hidden"> GINZA URBAN 21 BLDG. 6F
          </p>
          <p class="mb-4 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-3 h-5 w-5">
              <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z"/>
              <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z"/>
            </svg>
            <a href="mailto:info@spesclinic.com">info@spesclinic.com</a>
          </p>
          <p class="mb-4 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-3 h-5 w-5">
              <path fill-rule="evenodd"
                    d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                    clip-rule="evenodd"/>
            </svg>
            <a href="tel:0335286577">03-3528-6577</a>
          </p>

          <div class="pt-4">
            <div class="flex justify-center">
              <div class="w-80 md:w-fit">
                <p class="text-lg pb-2">〈診療時間〉10:00 ~ 19:00</p>
                <div class="border-y-2 py-2 text-lg">
                  完全予約制
                </div>
                <div class="flex flex-5 border-b-2">
                  <div class="border-r-2 text-xl w-24 py-2">火</div>
                  <div class="border-r-2 text-xl w-24 py-2">水</div>
                  <div class="border-r-2 text-xl w-24 py-2">木</div>
                  <div class="border-r-2 text-xl w-24 py-2">金</div>
                  <div class="text-xl w-24 py-2">土</div>
                </div>
                <div class="flex flex-5 border-b-2">
                  <div class="border-r-2 text-xl w-24 py-2">○</div>
                  <div class="border-r-2 text-xl w-24 py-2">○</div>
                  <div class="border-r-2 text-xl w-24 py-2">○</div>
                  <div class="border-r-2 text-xl w-24 py-2">○</div>
                  <div class="text-xl w-24 py-2">○</div>
                </div>
              </div>
            </div>
          </div>

        </section>
        <section class="tokyo_bay basis-1/2">
          <div class="flex p-10 md:pt-16 md:pb-12 justify-center items-center">
            <div>
              <img class="h-14 md:h-28" src="@/assets/img/logo/harumilogo.png" alt="harumi logo">
              <ul class="md:inline-flex gap-4 list-inside list-none mt-4">
                <li>● 内科(神経内科/消化器内科)</li>
                <li>● 皮膚科</li>
                <li>● 泌尿器科</li>
              </ul>
            </div>
          </div>
          <p class="mb-4 pb-6 flex items-center justify-center">
            <img class="w-5/6 md:w-1/2" src="@/assets/img/mapharumi.png" alt="map">
          </p>
          <p class="mb-6 flex items-center justify-center">
            <a href="https://maps.app.goo.gl/2wWJaL25DniXWMvA8" target="_blank"
               class="pt-3 text-center before:ease relative h-14 w-40 overflow-hidden border border-white shadow-2xl before:absolute before:left-0 before:-ml-2 before:h-48 before:w-48 before:origin-top-right before:-translate-x-full before:translate-y-12 before:-rotate-90 before:bg-gray-900 before:transition-all before:duration-300 hover:text-white hover:shadow-black hover:before:-rotate-180">
              <span class="relative z-10 font-thin">google map</span>
            </a>
          </p>
          <p class="mb-4 flex items-center justify-center">
            〒104-0053 東京都中央区晴海 2-1-40<br class="sm:block md:hidden"> 晴海プライムスクエア 11F
          </p>
          <p class="mb-4 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-3 h-5 w-5">
              <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z"/>
              <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z"/>
            </svg>
            <a href="mailto:info@spesclinic.com">info-harumi@spesclinic.jp</a>
          </p>
          <p class="mb-4 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-3 h-5 w-5">
              <path fill-rule="evenodd"
                    d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                    clip-rule="evenodd"/>
            </svg>
            <a href="tel:0362282100">03-6228-2100</a>
          </p>

          <div class="pt-4">
            <div class="flex justify-center">
              <div class="w-80 md:w-fit">
                <p class="text-lg pb-2">〈診療時間〉10:00 ~ 19:00</p>
                <div class="flex flex-5 border-y-2">
                  <div class="border-r-2 text-xl w-24 py-2">火</div>
                  <div class="border-r-2 text-xl w-24 py-2">水</div>
                  <div class="border-r-2 text-xl w-24 py-2">木</div>
                  <div class="border-r-2 text-xl w-24 py-2">金</div>
                  <div class="text-xl w-24 py-2">土</div>
                </div>
                <div class="flex flex-5 border-b-2">
                  <div class="border-r-2 text-xl w-24 py-2">佐 藤</div>
                  <div class="border-r-2 text-xl w-24 py-2">佐 藤</div>
                  <div class="border-r-2 text-xl w-24 py-2">小 川</div>
                  <div class="border-r-2 text-xl w-24 py-2">佐 藤</div>
                  <div class="text-xl w-24 py-2">田 口</div>
                </div>
                <div class="flex flex-5 border-b-2">
                  <div class="border-r-2 text-xl w-24 py-2">鶴 田</div>
                  <div class="border-r-2 text-xl w-24 py-2">浜</div>
                  <div class="border-r-2 text-xl w-24 py-2">鶴 田</div>
                  <div class="border-r-2 text-xl w-24 py-2">鶴 田</div>
                  <div class="text-xl w-24 py-2">鶴 田</div>
                </div>
              </div>
            </div>
          </div>

        </section>

      </div>
    </div>

    <!--Copyright section-->
    <div class="bg-neutral-200 p-6 text-center dark:bg-neutral-700">
      <span class="uppercase">© SPES clinic</span> All Rights Reserved.
    </div>
  </footer>
</template>
<script setup>
</script>